import styled from 'styled-components';

export const Root = styled.div`
    dislplay: flex;
    margin-left: 70px;
    margin-right: 70px;
`;

export const Title = styled.span`
    font-family: Roboto;
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
`;

interface IBoxProps {
    dragging: boolean;
}
export const Box = styled.div`
    width: 100%;
    height: 232px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
    border-radius: 5px;
    ${(props:IBoxProps) => props.dragging ? 'border: 2px solid #ff7319;' : ''}
    background-color: ${(props:IBoxProps) => props.dragging ? '#fffaf6' : '#ffffff'};
    margin-top: 16px;
    margin-bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    box-sizing: border-box;
`;

export const Text = styled.span`
    font-family: Roboto;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: rgba(112, 112, 112, 0.5);
    margin-top: 44px;
`
